<template>
  <div class="container">
    <div class="row">
      <div class="col-md-3 col-0" />
      <div class="col-md-6 col-12">
        <h5 class="mb-4 mt-4">Welcome to Special Data!</h5>
        <h5 class="text-danger" v-if="errorMessage != ''">
          {{ errorMessage }}
        </h5>
        <transition name="fade" mode="out-in">
          <form v-if="signingIn" @submit.prevent="signIn" key="signIn">
            <div class="form-group">
              <label for="email">Username</label>
              <input
                type="text"
                class="form-control"
                id="curUsername"
                aria-describedby="emailHelp"
                placeholder="Enter username"
                autocomplete="username"
                v-model="signInUsername"
                required
              />
            </div>
            <div class="form-group">
              <label for="password">Password</label>
              <input
                type="password"
                class="form-control"
                id="curPassword"
                placeholder="Password"
                autocomplete="current-password"
                v-model="signInPassword"
                required
              />
            </div>
            <div class="form-row">
              <div class="col text-left">
                <button
                  type="button"
                  v-on:click="signingIn = false"
                  class="btn btn-link"
                >
                  Create an Account
                </button>
                <button
                  type="button"
                  v-on:click="forgotPassword"
                  class="btn btn-link"
                >
                  Forgot My Password
                </button>
              </div>
              <div class="col text-right">
                <button type="submit" class="btn btn-primary">
                  Sign In
                </button>
              </div>
            </div>
          </form>
          <form v-else @submit.prevent="signUp" key="signUp">
            <div class="form-group">
              <label for="newFirstName">First Name</label>
              <input
                type="text"
                class="form-control"
                id="newFirstName"
                placeholder="First Name"
                v-model="newFirstName"
                required
              />
            </div>
            <div class="form-group">
              <label for="newLastName">Last Name</label>
              <input
                type="text"
                class="form-control"
                id="newLastName"
                placeholder="Last Name"
                v-model="newLastName"
                required
              />
            </div>
            <div class="form-group">
              <label for="newUserName">Username</label>
              <input
                type="text"
                class="form-control"
                id="newUserName"
                placeholder="Username"
                v-model="newUserName"
                required
              />
            </div>
            <div class="form-group">
              <label for="newPhone">Phone</label>
              <input
                type="text"
                class="form-control"
                id="newPhone"
                aria-describedby="phoneHelp"
                placeholder="Phone"
                v-model="newPhone"
              />
            </div>
            <div class="form-group">
              <label for="newEmail">Email Address</label>
              <input
                type="email"
                class="form-control"
                id="newEmail"
                aria-describedby="emailHelp"
                placeholder="Email"
                autocomplete="username"
                v-model="newEmail"
                required
              />
            </div>
            <div class="form-group">
              <label for="newConfirmEmail">Confirm Email Address</label>
              <input
                type="email"
                class="form-control"
                id="newConfirmEmail"
                aria-describedby="emailHelp"
                placeholder="Confirm Email"
                autocomplete="username"
                v-model="newConfirmEmail"
                required
              />
            </div>
            <div class="form-group">
              <label for="newPassword">Password</label>
              <input
                type="password"
                class="form-control"
                id="newPassword"
                placeholder="Password"
                v-model="newPassword"
                required
              />
            </div>
            <div class="form-group">
              <label for="newConfirmPassword">Confirm Password</label>
              <input
                type="password"
                class="form-control"
                id="newConfirmPassword"
                placeholder="Confirm Password"
                v-model="newConfirmPassword"
                required
              />
            </div>
            <div class="form-row">
              <div class="col text-left">
                <button
                  type="button"
                  v-on:click="signingIn = true"
                  class="btn btn-link"
                >
                  I Already Have an Account
                </button>
              </div>
              <div class="col text-right">
                <button type="submit" class="btn btn-primary">
                  Sign Up
                </button>
              </div>
            </div>
          </form>
        </transition>
      </div>
      <div class="col-md-3 col-0" />
    </div>
    <div class="row pb-4">
      <div class="col">
        <p>To download the app click the button or scan the QR code below.</p>
        <div class="row justify-content-center">
          <div class="col-auto">
            <a href="https://apps.apple.com/us/app/special-data/id1540105813?itsct=apps_box_badge&amp;itscg=30200" style="display: inline-block; overflow: hidden; border-radius: 13px; width: 250px; height: 83px;"><img src="https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/en-us?size=250x83&amp;releaseDate=1605225600&h=5cddb73cbece3ce689a60299d9f2201f" alt="Download on the App Store" style="border-radius: 13px; width: 250px; height: 83px;"></a>
          </div>
          <div class="col-auto">
            <img
              src="@/assets/qr-code.jpg"
              width="200"
              height="200"
              alt="QR Code"
            />
          </div>
        </div>
      </div>
    </div>
    <ForgotPasswordModal />
  </div>
</template>

<script>
//import { Auth } from "aws-amplify";
import Parse from "parse";
import ForgotPasswordModal from "@/modals/ForgotPasswordModal.vue";
import $ from "jquery";

export default {
  name: "SignIn",
  components: {
    ForgotPasswordModal
  },
  mounted() {
    if (this.$route.query.passwordchanged) {
      this.$showSnackbar("Your password has been changed.", true);
    }
  },
  data() {
    return {
      signingIn: true,
      signedIn: false,
      signInUsername: "",
      signInPassword: "",
      errorMessage: "",
      newEmail: "",
      newPhone: "",
      newConfirmEmail: "",
      newFirstName: "",
      newLastName: "",
      newPassword: "",
      newConfirmPassword: "",
      newUserName: ""
    };
  },
  methods: {
    async signUp() {
      var view = this;
      if (view.newEmail === view.newConfirmEmail && view.newPassword === view.newConfirmPassword) {
        view.$store.commit("updateLoading", true);
        const user = new Parse.User();
        user.set("username", view.newUserName);
        user.set("password", view.newPassword);
        user.set("email", view.newEmail);

        // other fields can be set just like with Parse.Object
        user.set("firstName", view.newFirstName);
        user.set("lastName", view.newLastName);
        user.set("phone", view.newPhone);

        try {
          await user.signUp();
          view.$store.commit("updateLoading", false);
          view.$router.push("v2Dashboard");
          // Hooray! Let them use the app now.
        } catch (error) {
          // Show the error message somewhere and let the user try again.
          alert("Error: " + error.code + " " + error.message);
          console.log(error);
        }
      } else {
        view.errorMessage =
          "The email address or password doesn't match. Please check and try again";
      }
    },
    async signIn() {
    // Create a new instance of the user class
      var view = this;
      Parse.User
          .logIn(view.signInUsername, view.signInPassword).then(function(user) {
            view.$store.commit("updateUser", user);
            console.log('User created successful with name: ' + user.get("username") + ' and email: ' + user.get("email"));
            view.$router.push("v2Dashboard");

            
      }).catch(function(error){
          view.errorMessage = error.message;
      });
    },
    forgotPassword() {
      $("#forgotPasswordModal").modal("show");
    }
  }
};
</script>
